module.exports = __webpack_public_path__ + "assets/img/fr-742f6c26.png";